import Option from "./Option";

export default Option;



// WEBPACK FOOTER //
// ./template/components/GDPR/Option/index.js